import { render, staticRenderFns } from "./KanapowiBuntownicy.vue?vue&type=template&id=2c5ea044&scoped=true&"
import script from "./KanapowiBuntownicy.vue?vue&type=script&lang=js&"
export * from "./KanapowiBuntownicy.vue?vue&type=script&lang=js&"
import style0 from "./KanapowiBuntownicy.vue?vue&type=style&index=0&id=2c5ea044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ea044",
  null
  
)

export default component.exports